import { cn } from "@/lib/utils";
import mascotNormal from "@/assets/mascot-normal.png";

interface MascotLoaderProps {
  message?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeConfig = {
  sm: {
    mascot: "h-16 w-16",
    steam: "h-6",
    text: "text-sm",
    gap: "gap-2",
  },
  md: {
    mascot: "h-24 w-24",
    steam: "h-10",
    text: "text-base",
    gap: "gap-3",
  },
  lg: {
    mascot: "h-32 w-32",
    steam: "h-14",
    text: "text-lg",
    gap: "gap-4",
  },
};

export function MascotLoader({ 
  message = "Finding your next spot...", 
  size = "md",
  className 
}: MascotLoaderProps) {
  const config = sizeConfig[size];

  return (
    <div className={cn("flex flex-col items-center justify-center", config.gap, className)}>
      {/* Mascot with Steam Container */}
      <div className="relative">
        {/* Animated Steam Wisps */}
        <div className={cn("absolute -top-2 left-1/2 -translate-x-1/2 flex items-end justify-center gap-1", config.steam)}>
          <div className="steam-wisp steam-wisp-1" />
          <div className="steam-wisp steam-wisp-2" />
          <div className="steam-wisp steam-wisp-3" />
        </div>

        {/* Mascot with gentle bobbing */}
        <div className="animate-mascot-bob">
          <img
            src={mascotNormal}
            alt="Loading..."
            className={cn(
              "object-contain mix-blend-multiply",
              config.mascot
            )}
          />
        </div>
      </div>

      {/* Loading Message */}
      <p className={cn(
        "text-muted-foreground font-medium animate-pulse",
        config.text
      )}>
        {message}
      </p>
    </div>
  );
}
